/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EffectiveLaborCostDto } from '../../models/effective-labor-cost-dto';

export interface GetEffectiveLaborCost$Params {
  id: string;
}

export function getEffectiveLaborCost(http: HttpClient, rootUrl: string, params: GetEffectiveLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveLaborCostDto>> {
  const rb = new RequestBuilder(rootUrl, getEffectiveLaborCost.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EffectiveLaborCostDto>;
    })
  );
}

getEffectiveLaborCost.PATH = '/v0/effectiveLaborCost/{id}';
